export function select (context, { result, replace = false }) {
  context.commit('selectResult', result)
  const router = this.$router
  const go = (replace ? router.replace : router.push).bind(router)

  if (result.origin === 'google') {
    result.layer.openPopup()
  } else if (result.origin === 'coordinates') {
    const params = {
      epsg: '4326',
      coords: result.coords
    }
    go({ name: 'coords', params })
  } else {
    const params = {
      q: result.title
    }
    go({ name: 'place', params })
  }
}

export function ensureEngine (context) {
  let Engine
  if (context.state.searchOption) {
    Engine = this.$config.advancedSearchEngine
  } else {
    Engine = this.$config.searchEngine
  }
  context.commit('engine', new Engine(this, context))
}

export async function search (context, { query, forceRefresh = false, auto }) {
  if (auto !== void 0) {
    context.commit('auto', auto)
  }
  context.dispatch('ensureEngine')
  if (!forceRefresh && query === context.state.query) {
    const autoSelect = context.state.auto !== false && context.dispatch('uniqueSelection')
    if (!autoSelect) {
      context.state.engine.showResultLayers()
    }
    return
  }

  context.commit('query', query)
  if (query) {
    context.commit('auto', auto !== false)
    context.dispatch('fetch')
  }
}
